import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { UserAssessmentAssignmentCreateInput } from '../generated/globalTypes';
import { createUserAssessmentAssignmentMutation, createUserAssessmentAssignmentMutationVariables } from '../generated/createUserAssessmentAssignmentMutation';
import { userAssessmentAssignmentFieldsFragment } from '../models/UserAssessmentAssignment';

/**
 * Get a callback to create a UserAssessmentAssignment in the store.
 */
export function useCreateUserAssessmentAssignmentCallback(): [(model: UserAssessmentAssignmentCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createUserAssessmentAssignmentMutation, createUserAssessmentAssignmentMutationVariables>(
        gql`
            mutation createUserAssessmentAssignmentMutation ($model: UserAssessmentAssignmentCreateInput!) {
                createUserAssessmentAssignment(model: $model) {
                    ...userAssessmentAssignmentFields
                }
            }

            ${userAssessmentAssignmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: UserAssessmentAssignmentCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
